import { account } from "./account";
import { action_points } from "./action-points";
import { assessment } from "./assessment";
import { auth } from "./auth";
import { brochure } from "./brochure";
import { callbacks } from "./callbacks";
import { career_path } from "./career-path";
import { chapters } from "./chapters";
import { contact_us } from "./contact";
import { contents } from "./contents";
import { course_enrollment } from "./course-enrollment";
import { courses } from "./courses";
import { data } from "./data";
import { departments } from "./departments";
import { groups } from "./groups";
import { guardians } from "./guardians";
import { instructors } from "./instructor";
import { live_sessions } from "./live-sessions";
import { organizations } from "./organizations";
import { payments } from "./payments";
import { qa } from "./qa";
import { question_bank } from "./question-bank";
import { questions } from "./questions";
import { ranks } from "./ranks";
import { resources } from "./resources";
import { roles } from "./roles";
import { school_guide } from "./school-guide";
import { setup } from "./setup";
import { staffs } from "./staffs";
import { students } from "./students";
import { topics } from "./topics";
import { two_fa } from "./two-fa";
import { unique_links } from "./unique-links";
import { upload } from "./upload";
import { users } from "./users";

export const http = {
  action_points,
  assessment,
  auth,
  brochure,
  career_path,
  chapters,
  contents,
  course_enrollment,
  courses,
  data,
  departments,
  groups,
  guardians,
  payments,
  live_sessions,
  question_bank,
  questions,
  roles,
  ranks,
  school_guide,
  staffs,
  setup,
  students,
  topics,
  two_fa,
  unique_links,
  upload,
  users,
  callbacks,
  instructors,
  resources,
  account,
  organizations,
  contact_us,
  qa,
};
